import api from '../../connections/api';
import routes_api from '../../connections/routes_api';

// View - Records
export const fetchHealthRecords = () => {
  return api.get(routes_api.health_records);
};

export const createHealthRecord = (data) => {
  return api.post(routes_api.health_records, data);
};

export const updateHealthRecord = (id, data) => {
  return api.put(`${routes_api.health_records}${id}/`, data);
};

export const deleteHealthRecord = (id) => {
  return api.delete(`${routes_api.health_records}${id}/`);
};

export const deleteAllHealthRecords = () => {
  return api.delete(routes_api.health_records_deleteall);
};

export const createManyHealthRecord = (data) => {
  return api.post(routes_api.health_records_createmany, data);
};

// View - Professionals
export const fetchHealthProfessionals = () => {
  return api.get(routes_api.health_professionals);
};

export const createHealthProfessional = (data) => {
  return api.post(routes_api.health_professionals, data);
};

export const updateHealthProfessional = (id, data) => {
  return api.put(`${routes_api.health_professionals}${id}/`, data);
};

export const deleteHealthProfessional = (id) => {
  return api.delete(`${routes_api.health_professionals}${id}/`);
};

export const getHealthEmbeddedNotepadCluster = async () => {
  return api.get(routes_api.health_embedded_notepad_cluster);
};

export const patchHealthEmbeddedNotepadCluster = async (linkedNotepadClusterId) => {
  return api.patch(routes_api.health_embedded_notepad_cluster, {
    linked_notepad_cluster_id: linkedNotepadClusterId,
  });
};
